export class OrderInvalidDeliveryFloorError extends Error {
    constructor() {
        super('ERROR_INVALID_DELIVERY_FLOOR');
    }
}
